module.exports = __webpack_public_path__ + "img/pro-photo1.001f92c3.png";